import { STORY_GROUPS } from '@/constants/STORY_GROUPS.ts'
import { STORY_STATUSES } from '@/constants/STORY_STATUSES.ts'

const { ACCEPTED, STARTED, FINISHED, DELIVERED, REJECTED, UNSTARTED, UNSCHEDULED } = STORY_STATUSES

export const isAccepted = (status: StoryStatus) => status === ACCEPTED
export const isInProgress = (status: StoryStatus) => [STARTED, FINISHED, DELIVERED, REJECTED].includes(status)
export const isUnstarted = (status: StoryStatus) => status === UNSTARTED
export const isUnscheduled = (status: StoryStatus) => status === UNSCHEDULED

export const getGroupName = (
  status?: StoryStatus,
  subgroup?: StorySubgroup | null,
): { group: StoryGroup; subgroup: StorySubgroup | null } => {
  if (!status) throw new Error(`Unknown status: ${status}`)

  switch (true) {
    case isAccepted(status):
      return { group: STORY_GROUPS.ACCEPTED, subgroup: null }
    case isInProgress(status):
      return { group: STORY_GROUPS.CURRENT, subgroup: null }
    case isUnstarted(status):
      return { group: STORY_GROUPS.SCHEDULED, subgroup: null }
    case isUnscheduled(status):
      return { group: STORY_GROUPS.UNSCHEDULED, subgroup: subgroup ?? 'DRAFT' }
    default:
      throw new Error(`Unknown status: ${status}`)
  }
}
